import React, { Component } from 'react';

class Settings extends Component {
    state = {
        settings: {
            notifications_enabled: true,
            email_alerts: true,
            theme: 'light',
            currency: 'USD',
            language: 'en'
        },
        loading: true,
        saving: false,
        error: null,
        success: null
    };

    componentDidMount() {
        this.fetchSettings();
    }

    fetchSettings = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/api/account/settings`;
            
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            });
            
            const result = await response.json();
            
            if (result.msg === 'User settings') {
                this.setState({ 
                    settings: result.settings,
                    loading: false 
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (error) {
            this.setState({ 
                error: 'Error fetching settings',
                loading: false 
            });
        }
    };

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState(prevState => ({
            settings: {
                ...prevState.settings,
                [name]: type === 'checkbox' ? checked : value
            },
            success: null,
            error: null
        }));
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        this.setState({ saving: true, error: null, success: null });
        
        try {
            const { settings } = this.state;
            
            const formData = new URLSearchParams();
            formData.append('notifications_enabled', settings.notifications_enabled);
            formData.append('email_alerts', settings.email_alerts);
            formData.append('theme', settings.theme);
            formData.append('currency', settings.currency);
            formData.append('language', settings.language);
            
            const url = `${process.env.REACT_APP_API_URL}/api/account/settings`;
            
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                },
                body: formData
            });
            
            const result = await response.json();
            
            if (result.msg === 'Settings updated') {
                this.setState({ 
                    settings: result.settings,
                    saving: false,
                    success: 'Settings saved successfully!'
                });
            } else {
                this.setState({ 
                    error: result.msg || 'Failed to save settings',
                    saving: false 
                });
            }
        } catch (error) {
            this.setState({ 
                error: 'Error saving settings',
                saving: false 
            });
        }
    };

    render() {
        const { settings, loading, saving, error, success } = this.state;

        if (loading) {
            return (
                <section className="settings">
                    <h2>Settings</h2>
                    <div className="loading">Loading settings...</div>
                </section>
            );
        }

        return (
            <section className="settings">
                <h2>Settings</h2>
                
                {error && (
                    <div className="alert alert-danger">{error}</div>
                )}
                
                {success && (
                    <div className="alert alert-success">{success}</div>
                )}
                
                <form onSubmit={this.handleSubmit} className="settings-form">
                    {/* Notifications Section */}
                    <div className="settings-section">
                        <h3>Notifications</h3>
                        
                        <div className="form-group checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="notifications_enabled"
                                    checked={settings.notifications_enabled}
                                    onChange={this.handleChange}
                                />
                                Enable in-app notifications
                            </label>
                            <p className="help-text">
                                Receive notifications about account activity, promotions, and updates.
                            </p>
                        </div>
                        
                        <div className="form-group checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="email_alerts"
                                    checked={settings.email_alerts}
                                    onChange={this.handleChange}
                                />
                                Email alerts for transactions
                            </label>
                            <p className="help-text">
                                Get email notifications for deposits, withdrawals, and transfers.
                            </p>
                        </div>
                    </div>
                    
                    {/* Appearance Section */}
                    <div className="settings-section">
                        <h3>Appearance</h3>
                        
                        <div className="form-group">
                            <label htmlFor="theme">Theme</label>
                            <select
                                id="theme"
                                name="theme"
                                value={settings.theme}
                                onChange={this.handleChange}
                                className="form-control"
                            >
                                <option value="light">Light</option>
                                <option value="dark">Dark</option>
                                <option value="system">System Default</option>
                            </select>
                        </div>
                    </div>
                    
                    {/* Regional Section */}
                    <div className="settings-section">
                        <h3>Regional</h3>
                        
                        <div className="form-group">
                            <label htmlFor="currency">Currency</label>
                            <select
                                id="currency"
                                name="currency"
                                value={settings.currency}
                                onChange={this.handleChange}
                                className="form-control"
                            >
                                <option value="USD">USD - US Dollar</option>
                                <option value="EUR">EUR - Euro</option>
                                <option value="GBP">GBP - British Pound</option>
                                <option value="JPY">JPY - Japanese Yen</option>
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="language">Language</label>
                            <select
                                id="language"
                                name="language"
                                value={settings.language}
                                onChange={this.handleChange}
                                className="form-control"
                            >
                                <option value="en">English</option>
                                <option value="es">Español</option>
                                <option value="fr">Français</option>
                                <option value="de">Deutsch</option>
                            </select>
                        </div>
                    </div>
                    
                    <div className="settings-actions">
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            disabled={saving}
                        >
                            {saving ? 'Saving...' : 'Save Settings'}
                        </button>
                    </div>
                </form>
            </section>
        );
    }
}

export default Settings;

